<template>
  <div class="bigBox">
    <div class="cardBox">
      <el-card class="card">
        <el-form :model="login" ref="login" label-width="100px" class="demo-ruleForm">
          <el-form-item label="账号" prop="id" :rules="[{ required: true, message: '账号不能为空' }]">
            <!-- { type: 'number', message: '账号必须为数字值' }, -->
            <el-input v-model.number="login.id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="passworld" :rules="[{ required: true, message: '密码不能为空' }]">
            <el-input show-password v-model="login.passworld" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('login')" v-loading.fullscreen.lock="loading">登录</el-button>
            <el-button @click="resetForm('login')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CryptoJS from 'crypto-js'
export default {
  name: 'login',
  data () {
    return {
      login: {
        id: '',
        passworld: ''
      },
      loading: false
    }
  },
  methods: {
    submitForm (formName) {
          console.log(this.$http)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          console.log(this.$http)
          this.$http.adminLogin({
              param: 'login',
              lu: this.login.id,
              lp: this.login.passworld
            })
            .then((res) => {
              if (res.data) {
                const date = new Date().toDateString()
                sessionStorage.setItem(
                  'VerificationBy',
                  this.encryptByDES(date, 'zt')
                )
                this.$router.push({
                  name: 'messageManage',
                  params: {
                    data: res.data
                  }
                })
              }
              this.$message(res.msg)
              this.loading = false
            })
        } else {
          this.loading = false
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    encryptByDES (message, key) {
      var keyHex = CryptoJS.enc.Utf8.parse(key)
      var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.ciphertext.toString()
    }
  }
}
</script>

<style scoped>
.bigBox {
  width: 100%;
  height: 100%;
  position: relative;
}

.cardBox {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
}

.card {
  width: 450px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminLogin.vue